import { ReactComponent as CalendarIconSVG } from "images/svg/calendar.svg";
import React, { memo } from "react";
import { SvgIcon } from "@material-ui/core";

export const CalendarIcon = memo(function CalendarIcon(props) {
  return <SvgIcon viewBox="0 0 15 12" component={CalendarIconSVG} {...props} />;
});
